import { render, staticRenderFns } from "./payment-thanks.vue?vue&type=template&id=df5afd0c&scoped=true"
import script from "./payment-thanks.vue?vue&type=script&lang=js"
export * from "./payment-thanks.vue?vue&type=script&lang=js"
import style0 from "./payment-thanks.vue?vue&type=style&index=0&id=df5afd0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df5afd0c",
  null
  
)

export default component.exports